import { jsx } from "react/jsx-runtime";
import { forwardRef } from "react";
import { ThemeProvider } from "@mui/material";
import { palette } from "../../../constants/colors/palette.js";
import { createTheme } from "../../../constants/create-theme/create-theme.js";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { MuiAlert } from "../../../themes/alert/alert.js";
import { MuiButton } from "../../../themes/button/button.js";
import "color-alpha";
import "../../../themes/typography/typography.js";
import { MuiDialog } from "../../../themes/dialog/dialog.js";
import "../../../themes/external-theme/external-theme.js";
import { MuiFilledInput } from "../../../themes/filled-input/filled-input.js";
import "../../../themes/pickers-popper/pickers-popper.js";
import { MuiPopover } from "../../../themes/popover/popover.js";
import { MuiRadio } from "../../../themes/radio/radio.js";
import { shadows } from "../../../themes/shadows/shadows.js";
import { MuiSwitch } from "../../../themes/switch/switch.js";
import { MuiTooltip } from "../../../themes/tooltip/tooltip.js";
import { AxiosProvider } from "./providers/axios-provider.js";
import { AppointmentsProvider } from "./providers/appointments-provider.js";
import "@mui/material/styles";
import "../../../themes/alert/components/ErrorIcon/ErrorIcon.js";
import "@mui/material/SvgIcon/index.js";
import "../../../themes/alert/components/InfoIcon/InfoIcon.js";
import "../../../themes/alert/components/SuccessIcon/SuccessIcon.js";
import "../../../themes/alert/components/WarningIcon/WarningIcon.js";
import "../../../themes/button/styles/external/bordered.styles.js";
import "../../../themes/button/styles/external/filled.styles.js";
import "../../../themes/button/styles/internal/bordered.styles.js";
import "../../../themes/button/styles/internal/borderless.styles.js";
import "../../../themes/button/styles/internal/filled.styles.js";
import "../../../themes/button/styles/internal/shadowed.styles.js";
import "../../../themes/typography/utils/defaultVariantMapping/defaultVariantMapping.js";
import "../../../themes/typography/utils/typographyVariants/typographyVariants.js";
import "../../../constants/breakpoints/breakpoints.js";
import "../../../themes/checkbox/checkbox.js";
import "../../../themes/checkbox/components/CheckedIcon/CheckedIcon.js";
import "../../../themes/checkbox/components/IndeterminateIcon/IndeterminateIcon.js";
import "../../../themes/form-control-label/form-control-label.js";
import "axios";
import "date-fns";
import "./hooks/useAppointments.js";
import "./helpers/common.js";
import "date-fns/locale";
import "./appointment-details.types.js";
const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false
    }
  }
});
const theme = createTheme({
  palette,
  shadows,
  components: {
    MuiButton,
    MuiPopover,
    MuiFilledInput,
    MuiRadio,
    MuiAlert,
    MuiDialog,
    MuiTooltip,
    MuiSwitch
  }
});
const withAppointmentDetailsProviders = (Component) => (
  // eslint-disable-next-line react/require-default-props
  forwardRef((props, ref) => /* @__PURE__ */ jsx(ThemeProvider, { theme, children: /* @__PURE__ */ jsx(AxiosProvider, { ...props, children: /* @__PURE__ */ jsx(QueryClientProvider, { client: queryClient, children: /* @__PURE__ */ jsx(AppointmentsProvider, { ...props, children: /* @__PURE__ */ jsx(Component, { ...props, ref }) }) }) }) }))
);
export {
  withAppointmentDetailsProviders
};
